var map = {
	"./ADE.svg": "LI1V",
	"./BRI.svg": "9S6e",
	"./CAR.svg": "MweT",
	"./COL.svg": "kpPL",
	"./ESS.svg": "4yGy",
	"./FRE.svg": "0/kA",
	"./GCS.svg": "3ODh",
	"./GEE.svg": "GD3c",
	"./GWS.svg": "F+lq",
	"./HAW.svg": "uocx",
	"./MEL.svg": "rZgR",
	"./NM.svg": "Bj9J",
	"./PA.svg": "yg+c",
	"./RIC.svg": "v4uv",
	"./STK.svg": "d7Db",
	"./SYD.svg": "KWKB",
	"./WB.svg": "ua/d",
	"./WCE.svg": "+9im",
	"./codesports.svg": "sd/s",
	"./shield-1.svg": "ebG7",
	"./shield-2.svg": "SmLF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KZtR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.svg$
// module id = KZtR
// module chunks = 1